import { useState, useEffect, useMemo, useRef, useContext } from 'react';
import ProgressBarSingle from '../../Components/ProgressBarSingle/ProgressBarSingle';
import GreenTick from '../../Assets/Images/green-tick.svg'
import { useParams, useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import WalkthroughProgressBar from '../../Components/WalkthroughProgress/WalkthroughProgressBar';
import WestIcon from '@mui/icons-material/West'
import EastIcon from '@mui/icons-material/East'
import { CheckCircleRounded } from '@mui/icons-material';
import unchecked from '../../Assets/Images/Unchecked.svg'
import { capitalize, CircularProgress } from '@mui/material';
import useEnsureAssessmentDetails from '../../Hooks/useEnsureAssessmentDetails';
import AssessmentQuestionContext from '../../Store/AssessmentQuestionContext';

const Walkthrough = () => {
  const [isWalkthroughStarted, setIsWalkthroughStarted] = useState(false);
  const [selectedMostAnswer, setSelectedMostAnswer] = useState(null);
  const [selectedLeastAnswer, setSelectedLeastAnswer] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [currentPhase, setCurrentPhase] = useState("multiple-choice");
  const [selectedAssessmentAnswer, setSelectedAssessmentAnswer] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [hoveredAnswer, setHoveredAnswer] = useState(null);
  const [showNextBtn, setShowNextBtn] = useState(false);
  const [prevBtnClicked, setPrevBtnClicked] = useState(false);
  const assessCtx = useContext(AssessmentQuestionContext)

  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation()
  const { id } = useParams();
  useEnsureAssessmentDetails(id, searchParams);

  const [clientId, setClientId] = useState(null)
  const [leader, setLeader] = useState(null);
  const [member, setMember] = useState(null);
  const [respondentName, setRespondentName] = useState(null);
  const [hasLeader, setHasLeader] = useState(false)
  const [fromBeforeYouBegin, setFromBeforeYouBegin] = useState(location?.state?.fromBeforeYouBegin)
  const [fromGetStarted, setFromGetStarted] = useState(location?.state?.fromGetStarted)
  const [isLoading, setIsLoading] = useState(false)
  const navigationSearch = () => {
    const navigationParams = new URLSearchParams(searchParams);
    ["userName", "orgId", "clientId", "leader", "member", "client"].forEach((key) => navigationParams.delete(key));
    return navigationParams.toString();
  };

  useEffect(() => {
    const storageKey = `searchParams-${id}`;
    const storedData = JSON.parse(localStorage.getItem(storageKey)) || {};

    const leaderParam = searchParams.get("leader");
    const memberParam = searchParams.get("member");
    const respondentParam = searchParams.get("respondentName");
    const clientIdParam = searchParams.get("clientId");

    if (!storedData.leader && leaderParam) {
      const newStoredData = {
        ...storedData,
        leader: leaderParam,
        member: storedData.member || memberParam || null,
        respondentName: storedData.respondentName || respondentParam || null,
        clientId: storedData.clientId || clientIdParam || null,
      };

      localStorage.setItem(storageKey, JSON.stringify(newStoredData));

      if (leaderParam) {
        setLeader(storedData.leader ? capitalize(storedData.leader) : null);
      }
      setMember(memberParam);
      setRespondentName(respondentParam);
      setClientId(clientIdParam)
      setHasLeader(!!leaderParam);
    } else {
      setLeader(storedData.leader ? capitalize(storedData.leader) : null);
      setMember(storedData.member || null);
      setRespondentName(storedData.respondentName || null);
      setHasLeader(!!storedData.leader);
      setClientId(storedData.clientId || null)
    }
  }, [id, searchParams]);

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem(`searchParams-${id}`)) || {};
    assessCtx?.setLeaderName(storedData.leader)

    setIsLoading(true)
    setTimeout(() => {
      setIsLoading(false)
    }, 1000);
  }, [])

  useEffect(() => {
    if (location.state?.activeStep !== undefined) {
      setActiveStep(location.state.activeStep);
      setIsWalkthroughStarted(true);
    }
  }, [location.state]);

  useEffect(() => {
    if (activeStep === 0 || activeStep === 1) setCurrentPhase('multiple-choice')
    else setCurrentPhase('assessment')
  }, [activeStep])

  const multiple_choice = () => {
    return [
      {
        "id": 2286,
        "question": `Select the statement that MOST accurately represents you.`,
        "answerType": "multiple-choice",
        "answers": [
          { "id": 10225, "desktopText": `${leader ? leader.split(" ")[0] : "I"} ${leader ? 'uses' : 'use'} logic and clear thinking to solve problems.` },
          { "id": 10226, "desktopText": `${leader ? leader.split(" ")[0] : "I"} ${leader ? 'relies' : 'trust'} ${leader ? "on" : "my"} instincts to make decisions.` },
          { "id": 10227, "desktopText": `${leader ? leader.split(" ")[0] : "I"} ${leader ? 'focuses' : 'focus'} on building connections and inspiring others.` },
          { "id": 10228, "desktopText": `${leader ? leader.split(" ")[0] : "I"} ${leader ? 'depends' : 'rely'} on ${leader ? "" : "my"} strength and determination to get things done.` }
        ]
      },
      {
        "id": 2287,
        "question": `Great! Now select the statement that LEAST accurately represents you.`,
        "answerType": "multiple-choice",
        "answers": [
          { "id": 10225, "desktopText": `${leader ? leader.split(" ")[0] : "I"} ${leader ? 'uses' : 'use'} logic and clear thinking to solve problems.` },
          { "id": 10226, "desktopText": `${leader ? leader.split(" ")[0] : "I"} ${leader ? 'relies' : 'trust'} ${leader ? "on" : "my"} instincts to make decisions.` },
          { "id": 10227, "desktopText": `${leader ? leader.split(" ")[0] : "I"} ${leader ? 'focuses' : 'focus'} on building connections and inspiring others.` },
          { "id": 10228, "desktopText": `${leader ? leader.split(" ")[0] : "I"} ${leader ? 'depends' : 'rely'} on ${leader ? "" : "my"} strength and determination to get things done.` }
        ]
      },
    ];
  };

  const assessment_que = () => {
    return [
      {
        "id": 2288,
        // "question": <>How often {leader ? "does" : "do"} {leader ? <b style={{ textTransform: 'capitalize' }}>{leader.split(" ")[0]}</b> : "you"} rely on {leader ? <b style={{ textTransform: 'capitalize' }}>{leader.split(" ")[0]}'s</b> : "your"} instincts when facing challenges?</>,
        "question": <>How often {leader ? "does" : "do"} {leader ? <b style={{ textTransform: 'capitalize' }}>{leader.split(" ")[0]}</b> : "you"} rely on instincts when facing challenges?</>,
        "answerType": "assessment",
        "answers": [
          { "id": 10225, "desktopText": "Never" },
          { "id": 10226, "desktopText": "Rarely" },
          { "id": 10227, "desktopText": "Occasionally" },
          { "id": 10228, "desktopText": "Sometimes" },
          { "id": 10229, "desktopText": "Frequently" },
          { "id": 10230, "desktopText": "Usually" },
          { "id": 10231, "desktopText": "Always" },
        ]
      },
    ]
  }

  const questions = useMemo(() => multiple_choice(), [leader]);
  const assessmentQuestions = useMemo(() => assessment_que(), [leader]);
  const questionCount = questions.length;
  const params = useParams()
  const navigate = useNavigate()



  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem(`walkthrough-answers-${params.id}`)) || {};
    setSelectedMostAnswer(storedData.selectedMostAnswer || null);
    setSelectedLeastAnswer(storedData.selectedLeastAnswer || null);
    setSelectedAssessmentAnswer(storedData.selectedAssessmentAnswer || null);
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const answeredStepsRef = useRef(new Set());

  useEffect(() => {
    const isAnswered = !isNextButtonDisabled(activeStep);

    if (isAnswered && answeredStepsRef.current.has(activeStep)) {
      setShowNextBtn(true);
      return;
    }

    if (isAnswered && !answeredStepsRef.current.has(activeStep)) {
      const timeoutId = setTimeout(() => {
        answeredStepsRef.current.add(activeStep);
        setShowNextBtn(true);
      }, 1000);

      return () => clearTimeout(timeoutId);
    }

    setShowNextBtn(false);
  }, [activeStep, selectedMostAnswer, selectedLeastAnswer, selectedAssessmentAnswer]);



  const highlightText = (text, leader, hasLeader) => {
    console.log('text', leader);

    const formattedLeader = leader
  ? leader
      ?.split(' ')
      ?.map(word =>
        word === word.toUpperCase()
          ? word
          : word
              ?.split('-')
              ?.map(
                part =>
                  part?.charAt(0)?.toUpperCase() + part?.slice(1)?.toLowerCase()
              )
              ?.join('-')
      )
      ?.join(' ')
  : '';

    let result = text
      .replace(/MOST/g, '<span class="most" style="color: #00577D; font-weight: 700;">MOST</span>')
      .replace(/LEAST/g, '<span class="least" style="color: #B6111F; font-weight: 700;">LEAST</span>');

    if (hasLeader) {
      const safeLeader = leader.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const leaderRegex = new RegExp(safeLeader, "g");
      result = result.replace(
        leaderRegex,
        `<span style="font-weight: 700;">${formattedLeader}</span>`
      );
    }

    return result;
  };

  const mostQuestion = questions[0];
  const leastQuestion = questions[1];

  const filteredLeastAnswers = leastQuestion.answers.filter(ans => ans.id !== selectedMostAnswer);

  const handleMostAnswerClick = (answerId) => {
    setSelectedMostAnswer(answerId);

    const storedAnswers = JSON.parse(localStorage.getItem(`walkthrough-answers-${params.id}`)) || {};
    localStorage.setItem(`walkthrough-answers-${params.id}`, JSON.stringify({
      ...storedAnswers,
      selectedMostAnswer: answerId
    }));

    setTimeout(() => {
      setActiveStep(1);
    }, 1000);
  };

  const handleLeastAnswerClick = (answerId) => {
    setSelectedLeastAnswer(answerId);

    const storedAnswers = JSON.parse(localStorage.getItem(`walkthrough-answers-${params.id}`)) || {};
    localStorage.setItem(`walkthrough-answers-${params.id}`, JSON.stringify({
      ...storedAnswers,
      selectedMostAnswer,
      selectedLeastAnswer: answerId
    }));

    setTimeout(() => {
      if (activeStep === 1) {
        setActiveStep(2);
        setCurrentPhase("assessment");
      }
    }, 1000);
  };

  const handleAssessmentAnswerClick = (answerId) => {
    setSelectedAssessmentAnswer(answerId);

    const storedAnswers = JSON.parse(localStorage.getItem(`walkthrough-answers-${params.id}`)) || {};
    localStorage.setItem(`walkthrough-answers-${params.id}`, JSON.stringify({
      ...storedAnswers,
      selectedMostAnswer,
      selectedLeastAnswer,
      selectedAssessmentAnswer: answerId
    }));


    setTimeout(() => {
      if (activeStep === 2) {
        setActiveStep(3);
      }
    }, 1000);

    setTimeout(() => {
      navigate(`/get-started/${params.id}/?${navigationSearch()}`, { replace: true });
    }, 1500);
  };


  const moveToPrevQuestion = () => {
    setPrevBtnClicked(true)
    if (Math.min(activeStep + 1, questionCount + assessmentQuestions.length) <= 0) {
      navigate(`/before-you-begin/${params.id}/?${navigationSearch()}`, {
        replace: true,
      });
    } else if (activeStep === 0) {
    setTimeout(() => {
        setIsWalkthroughStarted(false)
    }, 1000)
    }
    else {
      setTimeout(() => {
        setActiveStep(ac => ac - 1)
      }, 1000)
    }
  }

  console.log("selectedAssessmentAnswer", selectedAssessmentAnswer)

  const moveToNextQuestion = () => {
    const totalQuestions = questionCount + assessmentQuestions.length;
    if (activeStep === totalQuestions - 1) {
      setTimeout(() => {
        setActiveStep(activeStep + 1)
      }, 1000)
      const answer = localStorage.getItem(`walkthrough-answers-${params.id}`)
      const answerId = answer.selectedAssessmentAnswer
      if (selectedAssessmentAnswer === answerId) {
        setSelectedAssessmentAnswer(answerId);
      }
      setTimeout(() => {
        navigate(`/get-started/${params.id}/?${navigationSearch()}`, { replace: true });
      }, 1500);
    } else {
      setTimeout(() => {
        setActiveStep(activeStep + 1);
      }, 1000);
    }
  }

  const isNextButtonDisabled = (activeStep) => {
    if (activeStep === 0 && !selectedMostAnswer) return true;
    else if (activeStep === 1 && !selectedLeastAnswer) return true;
    else if (activeStep === 2 && !selectedAssessmentAnswer) return true;
    else return false;
  };

  function isThisOptionSelected(selectedAnswers, ans) {
    if (mostQuestion.answers > 0) {
      if (selectedAnswers === ans.desktopText) {
        return true;
      }
    }
    else if (leastQuestion.answers > 0) {
      if (selectedAnswers === ans.desktopText) {
        return true;
      }
    }
    return false;
  }

  console.log('mostQuestion', mostQuestion)

  const formattedLeader = leader
  ? leader
      ?.split(' ')
      ?.map(word =>
        word === word.toUpperCase()
          ? word
          : word
              ?.split('-')
              ?.map(
                part =>
                  part?.charAt(0)?.toUpperCase() + part?.slice(1)?.toLowerCase()
              )
              ?.join('-')
      )
      ?.join(' ')
  : '';

  if (isLoading) {
    return <div className="container assessment loading"><CircularProgress style={{ color: '#00577D' }} size={60} /></div>
  }

  return (
    <div className='container-walkthrough'>
      {!isWalkthroughStarted ? (
        <div className='before-walkthrough'>
          {windowWidth > 650 ?
            <h1>Great! Get a quick walkthrough of <br /> the controls in this assessment.</h1>
            :
            <h1>Great! Get a quick <br /> walkthrough of the controls <br /> in this assessment.</h1>
          }
          {windowWidth > 650 ?
            <div className="buttons">
              <button
                className={`back-btn`}
                onClick={() => navigate(`/before-you-begin/${params.id}/?${navigationSearch()}`)}
              // disabled={currentIndex === 0}
              >
                < WestIcon /> Back
              </button>
              <button
                className="next-btn"
                onClick={() => setIsWalkthroughStarted(true)}
              // disabled={currentIndex === categories.length - 1}
              >
                Start Walkthrough  <EastIcon />
              </button>
            </div>
            :
            <div className="buttons-mobile">
              <button
                className={`back-btn`}
                onClick={() => navigate(`/before-you-begin/${params.id}/?${navigationSearch()}`, {
                  replace: true,
                  state: { fromBack: true }
                })}
              // disabled={currentIndex === 0}
              >
                < WestIcon /> Back
              </button>
              <button
                className="next-btn"
                onClick={() => setIsWalkthroughStarted(true)}
              // disabled={currentIndex === categories.length - 1}
              >
                Start Walkthrough <EastIcon />
              </button>
            </div>
          }
          {/* <button className='walkthrough-btn' onClick={() => setIsWalkthroughStarted(true)}>
          Start Walkthrough
        </button> */}
        </div>
      ) : (
        <>
          {/* <ProgressBarSingle 
          currentProgress={activeStep} 
          totalNumOfQuestions={questionCount + assessmentQuestions.length} 
          color="#00577D"
          currentSectionName={"Practice Question"}
        /> */}
          <WalkthroughProgressBar currentProgress={activeStep}
            totalNumOfQuestions={questionCount + assessmentQuestions.length}
            color="#00577D"
            currentSectionName={"Practice Question"}
          fromBeforeYouBegin={fromBeforeYouBegin}
          fromGetStarted={fromGetStarted}
          isWalkthroughStarted={isWalkthroughStarted}
          />

          <p className="question-count">
            {Math.min(activeStep + 1, questionCount + assessmentQuestions.length)}/{questionCount + assessmentQuestions.length}
          </p>

          <div className='walkthrough-questions'>
            {currentPhase === "multiple-choice" ? (
              activeStep === 0 ? (
                <div className='question'>
                  <h2 dangerouslySetInnerHTML={{ __html: highlightText(mostQuestion.question.replace("you.", hasLeader ? leader + "." : "you."), leader, hasLeader) }} />
                  <ul className='multiple-choice'>
                    {mostQuestion.answers.map((answer) => (
                      <li key={answer.id}>
                        <button
                          className='answer-btn'
                          onClick={() => handleMostAnswerClick(answer.id)}
                          style={{
                            backgroundColor: selectedMostAnswer === answer.id ? "#00577D" : "",
                            color: selectedMostAnswer === answer.id ? "#FFF" : ""
                          }}
                        >
                          {selectedMostAnswer === answer.id ? (
                            <img
                              src={GreenTick}
                              alt="Selected Icon"
                              style={{ width: "20px", height: "20px", marginRight: "10px" }}
                            />
                          ) : (
                            isThisOptionSelected(selectedMostAnswer, answer) ? <CheckCircleRounded className="tick-icon" /> : <img src={unchecked} style={{ width: '20px', marginRight: '12px' }} />
                          )}
                          {answer.desktopText}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <div className='question'>
                  <h2 dangerouslySetInnerHTML={{ __html: highlightText(leastQuestion.question.replace("you.", hasLeader ? leader + "." : "you."), leader, hasLeader) }} />
                  <ul className='multiple-choice'>
                    {filteredLeastAnswers.map((answer) => (
                      <li key={answer.id}>
                        <button
                          className='answer-btn'
                          onClick={() => handleLeastAnswerClick(answer.id)}
                          style={{
                            backgroundColor: selectedLeastAnswer === answer.id ? "#B6111F" : "",
                            color: selectedLeastAnswer === answer.id ? "#FFF" : ""
                          }}
                        >
                          {selectedLeastAnswer === answer.id ? (
                            <img
                              src={GreenTick}
                              alt="Selected Icon"
                              style={{ width: "20px", height: "20px", marginRight: "10px" }}
                            />
                          ) : (
                            isThisOptionSelected(selectedLeastAnswer, answer) ? <CheckCircleRounded className="tick-icon" /> : <img src={unchecked} style={{ width: '20px', marginRight: '12px' }} />

                          )}
                          {answer.desktopText}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )
            ) : (
              <div className='question'>
                <p className="que-headline">Select the response that most often represents {hasLeader ? <b>{formattedLeader}</b> : "you"}. </p>
                <h2 className="asmt-que">{assessmentQuestions[0].question}</h2>
                <ul className='slider-buttons'>
                  {assessmentQuestions[0].answers.map((answer) => (
                    <div className="btns-container" onMouseEnter={() => setHoveredAnswer(answer.id)} onMouseLeave={() => setHoveredAnswer(null)}>
                      <li key={answer.id} style={{
                        backgroundColor: selectedAssessmentAnswer === answer.id ? "#00577D" : hoveredAnswer === answer.id ? "#FBEFD4" : "",
                        color: selectedAssessmentAnswer === answer.id ? "#FFF" : ""
                      }}>
                        <button
                          onClick={() => handleAssessmentAnswerClick(answer.id)}
                          onMouseEnter={() => setIsHovered(true)}
                          onMouseLeave={() => setIsHovered(false)}
                          className='answers'
                          style={{
                            backgroundColor: selectedAssessmentAnswer === answer.id ? "#00577D" : hoveredAnswer === answer.id ? "#FBEFD4" : "",
                            color: selectedAssessmentAnswer === answer.id ? "#FFF" : ""
                          }}>
                          {answer.desktopText}
                        </button>
                      </li>
                    </div>
                  ))}
                </ul>
              </div>
            )}
          </div>
          <div className="buttons">
            <button
              className="back-btn"
              onClick={() => moveToPrevQuestion()}
            // disabled={currentIndex === 0}
            >
              < WestIcon /> Back
            </button>
            {!isNextButtonDisabled(activeStep) && showNextBtn && (
              <button className="next-btn" onClick={() => moveToNextQuestion()}>
                Next <EastIcon />
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Walkthrough;
